import type { AnchorHTMLAttributes } from 'react';

// An off-site anchor: a new tab, and no referrer for a mailto.
export default function ExternalLink({
  href,
  ...rest
}: AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }) {
  return (
    <a
      href={href}
      rel={href.startsWith('mailto:') ? 'noreferrer' : 'noopener noreferrer'}
      target="_blank"
      {...rest}
    />
  );
}
